import { render } from "./FilterGroupRole.vue?vue&type=template&id=7bef0c2c"
import script from "./FilterGroupRole.vue?vue&type=script&lang=js"
export * from "./FilterGroupRole.vue?vue&type=script&lang=js"
script.render = render

export default script